import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck, ArrowLeft } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";
import AuthShell from "../components/AuthShell";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset your password"
      subtitle="We'll email you a link to set a new password."
      footer={
        <Link to="/login" className="inline-flex items-center gap-1.5 font-medium text-blue-600 hover:text-blue-700" data-testid="back-to-login">
          <ArrowLeft size={14} /> Back to sign in
        </Link>
      }
    >
      {sent ? (
        <div className="rounded-lg border border-emerald-200 bg-emerald-50 p-5 text-center" data-testid="reset-sent">
          <MailCheck className="mx-auto mb-2 text-emerald-600" size={28} />
          <p className="text-sm text-emerald-800">
            If an account exists for <span className="font-mono font-medium">{email}</span>, a reset link is on its way.
          </p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div className="space-y-1.5">
            <Label htmlFor="email" className="text-xs font-semibold">Email</Label>
            <Input
              id="email"
              type="email"
              data-testid="forgot-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              required
              className="focus:ring-2 focus:ring-blue-500"
            />
          </div>
          {error && <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600">{error}</p>}
          <Button
            type="submit"
            disabled={loading}
            data-testid="forgot-submit-btn"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white"
          >
            {loading && <Loader2 size={16} className="mr-2 animate-spin" />}
            Send reset link
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
